import { Button } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { ArrowIcon, ConvertIcon, PlusIcon } from 'BreetAssets';
import { getTargetEnvironment, isSandboxEnvironment } from 'BreetHelpers';
import { useModalApi, usePermissions } from 'BreetHooks';
import { selectIsApprovedForLive, selectUserData, useAppSelector } from 'BreetRedux';

export const HeaderCTA = ({ bottom }: { bottom?: boolean }) => {
	const { handleOpenModal } = useModalApi();

	const { hasPermission } = usePermissions();

	const isApprovedForLive = useAppSelector(selectIsApprovedForLive);
	const user = useAppSelector(selectUserData);

	const isAdmin = user?.businessRole === 'owner';

	const isKybCompleted =
		!isAdmin || isSandboxEnvironment(getTargetEnvironment()) || !!isApprovedForLive || !!user.approvedForLive;

	const openOnboarding = handleOpenModal({ id: 'onBoardingTodoList', wrapperClassName: 'onboarding-todolist-wrapper' });

	const fundWallet = handleOpenModal({ id: 'fundWallet', variant: 'right-sheet' });
	const withdraw = handleOpenModal({ id: 'requestPayment', variant: 'right-sheet' });
	const convert = handleOpenModal({ id: 'convertCurrency', variant: 'right-sheet' });

	return (
		<div
			className={classNameMerger('home-header-cta', bottom ? 'mobile' : 'desktop')}
			data-tour='wallet-actions'
		>
			{hasPermission('payments') && (
				<>
					<Button
						trailingIcon={<PlusIcon />}
						className='fund'
						onClick={isKybCompleted ? fundWallet : openOnboarding}
					>
						Fund Wallet
					</Button>
					<Button
						trailingIcon={<ArrowIcon variant='arrowDown' />}
						className='withdraw'
						onClick={isKybCompleted ? withdraw : openOnboarding}
					>
						Withdraw
					</Button>
					<Button
						trailingIcon={<ConvertIcon />}
						className='convert'
						onClick={isKybCompleted ? convert : openOnboarding}
					>
						Convert
					</Button>
				</>
			)}
		</div>
	);
};
